const ProtectionTypes = {
    options: [
        {value: "ECA", label: "Estatuto da Criança e do Adolescente"},
        {value: "ELDERLY_STATUTE", label: "Estatuto do Idoso"},
        {value: "MARIA_DA_PENHA", label: "Maria da Penha"},
        {value: "OTHER", label: "Outros"},
    ],

    getProtectionTypes: () => {
        return ProtectionTypes.options;
    },

    toView: (type) => {
        if (!type) return "";

        return ProtectionTypes.options.find(({value}) => type === value)?.label ?? "";
    }
}

export default ProtectionTypes;